"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeQuery = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class DateRangeQuery extends base_models_1.Serializable {
}
exports.DateRangeQuery = DateRangeQuery;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        description: 'From date',
        example: '2022-12-09',
    }),
    (0, class_validator_1.IsDateString)(),
    tslib_1.__metadata("design:type", String)
], DateRangeQuery.prototype, "from", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        description: 'To date',
        example: '2022-12-09',
    }),
    (0, class_validator_1.IsDateString)(),
    tslib_1.__metadata("design:type", String)
], DateRangeQuery.prototype, "to", void 0);
